var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileScreenLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 104,
    viewBox: "0 0 65 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.36966,
    y: 7.36966,
    width: 54.2607,
    height: 93.2607,
    stroke: "black",
    strokeWidth: 0.739318
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3697,
    y: 4.36966,
    width: 6.26068,
    height: 6.26068,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.739318
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3697,
    y: 97.3697,
    width: 6.26068,
    height: 6.26068,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.739318
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.369659,
    y: 4.36966,
    width: 6.26068,
    height: 6.26068,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.739318
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.369659,
    y: 97.3697,
    width: 6.26068,
    height: 6.26068,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.739318
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9993 7.12696L63.9993 1H57.8723L60.3182 3.44586L52.4467 11.3174L50 8.87066V14.9976H56.127L53.6841 12.5548L61.5556 4.68326L63.9993 7.12696Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9993 1L64.4368 1L64.4368 0.562515H63.9993V1ZM63.9993 7.12696L63.6899 7.43631L64.4368 8.18314V7.12696H63.9993ZM57.8723 1V0.562515H56.8162L57.563 1.30935L57.8723 1ZM60.3182 3.44586L60.6275 3.75521L60.9369 3.44586L60.6275 3.13651L60.3182 3.44586ZM52.4467 11.3174L52.1374 11.6267L52.4467 11.9361L52.756 11.6267L52.4467 11.3174ZM50 8.87066L50.3093 8.56131L49.5625 7.81448V8.87066H50ZM50 14.9976H49.5625V15.4351H50V14.9976ZM56.127 14.9976V15.4351H57.1831L56.4363 14.6883L56.127 14.9976ZM53.6841 12.5548L53.3747 12.2454L53.0654 12.5548L53.3747 12.8641L53.6841 12.5548ZM61.5556 4.68326L61.8649 4.37391L61.5556 4.06456L61.2462 4.37391L61.5556 4.68326ZM63.5618 1L63.5618 7.12696H64.4368L64.4368 1L63.5618 1ZM57.8723 1.43749H63.9993V0.562515H57.8723V1.43749ZM60.6275 3.13651L58.1817 0.690651L57.563 1.30935L60.0088 3.75521L60.6275 3.13651ZM52.756 11.6267L60.6275 3.75521L60.0088 3.13651L52.1374 11.008L52.756 11.6267ZM49.6907 9.18001L52.1374 11.6267L52.756 11.008L50.3093 8.56131L49.6907 9.18001ZM50.4375 14.9976V8.87066H49.5625V14.9976H50.4375ZM56.127 14.5601H50V15.4351H56.127V14.5601ZM53.3747 12.8641L55.8176 15.307L56.4363 14.6883L53.9934 12.2454L53.3747 12.8641ZM61.2462 4.37391L53.3747 12.2454L53.9934 12.8641L61.8649 4.99261L61.2462 4.37391ZM64.3086 6.81761L61.8649 4.37391L61.2462 4.99261L63.6899 7.43631L64.3086 6.81761Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.53906,
    y: 15,
    width: 41.925,
    height: 78,
    rx: 4.32501,
    fill: "#6161FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1133,
    y: 18.9004,
    width: 9.75,
    height: 2.925,
    rx: 1.4625,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileScreenLogo);
export default __webpack_public_path__ + "static/media/mobile-screen-logo.e5f132d78817804994b9a1375fb29c99.svg";
export { ForwardRef as ReactComponent };